// Country name → ISO 3166-1 alpha-2 code lookup (50+ travel destinations)
const COUNTRY_TO_ISO = {
  'afghanistan': 'AF', 'albania': 'AL', 'argentina': 'AR', 'australia': 'AU',
  'austria': 'AT', 'belgium': 'BE', 'bolivia': 'BO', 'bosnia and herzegovina': 'BA',
  'brazil': 'BR', 'cambodia': 'KH', 'canada': 'CA', 'chile': 'CL',
  'china': 'CN', 'colombia': 'CO', 'costa rica': 'CR', 'croatia': 'HR',
  'cuba': 'CU', 'czech republic': 'CZ', 'czechia': 'CZ', 'denmark': 'DK',
  'dominican republic': 'DO', 'ecuador': 'EC', 'egypt': 'EG', 'england': 'GB',
  'estonia': 'EE', 'ethiopia': 'ET', 'faroe islands': 'FO', 'fiji': 'FJ',
  'finland': 'FI', 'france': 'FR', 'germany': 'DE', 'greece': 'GR',
  'guatemala': 'GT', 'hungary': 'HU', 'iceland': 'IS', 'india': 'IN',
  'indonesia': 'ID', 'ireland': 'IE', 'israel': 'IL', 'italy': 'IT',
  'jamaica': 'JM', 'japan': 'JP', 'jordan': 'JO', 'kenya': 'KE',
  'laos': 'LA', 'latvia': 'LV', 'lithuania': 'LT', 'luxembourg': 'LU',
  'malaysia': 'MY', 'maldives': 'MV', 'malta': 'MT', 'mexico': 'MX',
  'monaco': 'MC', 'montenegro': 'ME', 'morocco': 'MA', 'myanmar': 'MM',
  'namibia': 'NA', 'nepal': 'NP', 'netherlands': 'NL', 'new zealand': 'NZ',
  'nicaragua': 'NI', 'norway': 'NO', 'oman': 'OM', 'panama': 'PA',
  'peru': 'PE', 'philippines': 'PH', 'poland': 'PL', 'portugal': 'PT',
  'romania': 'RO', 'russia': 'RU', 'scotland': 'GB', 'senegal': 'SN',
  'serbia': 'RS', 'singapore': 'SG', 'slovakia': 'SK', 'slovenia': 'SI',
  'south africa': 'ZA', 'south korea': 'KR', 'spain': 'ES', 'sri lanka': 'LK',
  'sweden': 'SE', 'switzerland': 'CH', 'taiwan': 'TW', 'tanzania': 'TZ',
  'thailand': 'TH', 'tunisia': 'TN', 'turkey': 'TR', 'turkiye': 'TR',
  'ukraine': 'UA', 'united arab emirates': 'AE', 'uae': 'AE',
  'united kingdom': 'GB', 'uk': 'GB', 'united states': 'US', 'usa': 'US',
  'uruguay': 'UY', 'vietnam': 'VN', 'wales': 'GB', 'zanzibar': 'TZ',
};

// Convert 2-letter ISO code to flag emoji using regional indicator symbols
function isoToFlag(iso) {
  if (!iso || iso.length !== 2) return "";
  return String.fromCodePoint(
    ...iso.toUpperCase().split("").map(c => 0x1F1E6 + c.charCodeAt(0) - 65)
  );
}

// Convert country name (and optional ISO code) to flag emoji
// Returns "" if country not recognized (graceful fallback)
export function countryToFlag(countryName, countryCode) {
  if (countryCode && countryCode.length === 2) {
    return isoToFlag(countryCode);
  }
  if (!countryName) return "";
  const iso = COUNTRY_TO_ISO[countryName.toLowerCase().trim()];
  return iso ? isoToFlag(iso) : "";
}
